/* eslint-disable */

import { memo, useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import menuItem from 'menu-items';
import NavGroup from './NavGroup';
import useConfig from 'hooks/useConfig';
import { Menu } from 'menu-items/widget';

import LAYOUT_CONST from 'constant';
import { HORIZONTAL_MAX_ITEM } from 'config';
import useAuth from 'hooks/useAuth';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ListingActions } from 'store/slices/listings';
import axiosServices from 'utils/axios';
import { EmployeeActions } from 'store/slices/employees';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { role, user } = useAuth();

    const [menuItems, setMenuItems] = useState();
    const theme = useTheme();
    const { layout } = useConfig();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const { propertiesCount } = useSelector((state) => state.listings);
    const { cancelCount, reinstatementCount: reinstateCount } = useSelector((state) => state.employee);
    const { getCount } = ListingActions;
    const { loadRequestsCount } = EmployeeActions;
    const dispatch = useDispatch();

    // Count In SideBar
    const [countData, setCountData] = useState(null);
    const location = useLocation();

    useEffect(() => {
        dispatch(getCount());
        dispatch(loadRequestsCount());
    }, [location, role, user?.email]);

    // const getMenu = Menu();
    const filteredMenuItems = menuItem.items.map((item) => {
        if (user?.status !== 'VERIFIED') {
            // If user status is not 'Active', disabled: true for each child
            return {
                ...item,
                children: item.children.map((child) => ({
                    ...child,
                    disabled: true
                }))
            };
        } else if (role === 'ADMIN' || role === 'SUPER_ADMIN') {
            // 1) Inject the blue “new” dot on the *Clients* collapse
            item.children = item?.children?.map(child => {
                if (child.id === 'customers') {
                    return {
                        ...child,
                        title: cancelCount?.count > 0 || reinstateCount?.count > 0
                         ?  
                         <>
                            <Stack direction='row' gap={1}>
                                <Typography variant='h5'>Clients</Typography>
                                <span style=
                                    {{backgroundColor:'#2196f3',
                                    color:'#fff',
                                    borderRadius:'4px',
                                    padding:'0 6px',
                                    fontSize:'13px',}}
                                >
                                    {cancelCount?.count+reinstateCount?.count}
                                </span>
                            </Stack>
                         </>
                    : 'Clients'
                    }
                }
                return child;
            })

            // 2) Tweak the two sub‐items under “Clients”
            item.children[1].children = item.children[1].children.map(child => {
              if (child.id === 'cancellation-requests') {
                return {
                  ...child,
                  title: cancelCount?.count > 0
                    ? `Cancellation Requests
                       <span style="
                         background-color:#f44336;
                         color:#fff;
                         border-radius:4px;
                         padding:0 6px;
                         font-size:13px;
                         margin-left:4px;
                       ">
                         ${cancelCount?.count}
                       </span>`
                    : 'Cancellation Requests'
                };
              } else if (child.id === 'reinstate-request') {
                return {
                  ...child,
                  title: reinstateCount?.count > 0
                    ? `Reinstatement Requests
                       <span style="
                         background-color:#4caf50;
                         color:#fff;
                         border-radius:4px;
                         padding:0 6px;
                         font-size:13px;
                         margin-left:4px;
                       ">
                         ${reinstateCount?.count}
                       </span>`
                    : 'Reinstatement Requests'
                };
              }
              return child;
            });
            item.children[2].children = item.children[2].children.map((child) => {
                if (child.id === 'manage-listing') {
                    return {
                        ...child,
                        title: `Manage Listing`
                    };
                } else if (child.id === 'archived-listing') {
                    return {
                        ...child,
                        title: propertiesCount?.totalPendingArchiveProperties
                            ? `Archived Listing 
                            <span 
                                style="
                                    background-color: #ef9a9a !important;
                                    color: white !important;
                                    border-radius: 2px !important;
                                    width: 10px !important;
                                    height: 10px !important;
                                    padding: 2px 4px 2px 4px !important;
                                    font-size: 10px !important;
                                    display: absolute !important;
                                    line-height: 5px !important;
                                    text-align: center !important;
                                "
                            >
                                ${propertiesCount?.totalPendingArchiveProperties || 0}
                            </span>
                            `
                            : 'Archived Listing'
                    };
                } else if (child.id === 'trashed-listing') {
                    return {
                        ...child,
                        title: `Trashed Listing`
                    };
                } else {
                    return child;
                }
            });
            return item;
        } else {
            // If the role is not 'ADMIN' remove the items
            item.children[2].children = item.children[2].children.map((child) => {
                if (child.id === 'archived-listing') {
                    return {
                        ...child,
                        title: 'Archived Listing'
                    };
                } else {
                    return child;
                }
            });

            return {
                ...item,
                children: item.children.filter((child) => child.id !== 'clients')
            };
        }
    });

    useEffect(() => {
        const object = {
            items: filteredMenuItems
        };

        setMenuItems(object);
    }, [countData, location]);

    // last menu-item to show in horizontal menu bar
    const lastItem = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd ? HORIZONTAL_MAX_ITEM : null;

    let lastItemIndex = menuItems?.items?.length - 1;
    let remItems = [];
    let lastItemId;

    if (lastItem && lastItem < menuItems?.items.length) {
        lastItemId = menuItems?.items[lastItem - 1].id;
        lastItemIndex = lastItem - 1;
        remItems = menuItems?.items.slice(lastItem - 1, menuItems?.items.length).map((item) => ({
            title: item.title,
            elements: item.children
        }));
    }

    const navItems = menuItems?.items.slice(0, lastItemIndex + 1).map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} lastItem={lastItem} remItems={remItems} lastItemId={lastItemId} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
